var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-component"},[(!_vm.hideButton)?_c('md-button',{staticClass:"btn btn-nonenary",class:'btn-' + _vm.size,attrs:{"disabled":_vm.buttonsDisabled,"color":'btn-' + _vm.color},on:{"click":function($event){return _vm.emitFunction()}}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }